import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { AssigneeChart } from 'src/features/boards/components/Analytics/AssigneeChart';
import {
  AssigneeWorkload,
  CompletionStatus,
  TaskColumnStatus,
  TaskCountAssignee,
} from 'src/features/boards/components/Analytics/charts';
import { Chip } from 'src/features/boards/components/Analytics/Chip';
import {
  getCompletedTasks,
  getIncompleteTasks,
  getOverDueTasks,
  getTotalTasks,
  groupTasksByAssignees,
} from 'src/features/boards/components/Analytics/utils';
import { useKanbanStore } from 'src/features/kanban';
import { KanbanState } from 'src/features/kanban/store/types';
import { shallow } from 'zustand/shallow';

import { getAnalyticsForSprint, getFileAnalytics } from '../../api/useAgileService';
import { useAgileStore } from '../../store';
import { BurnDownChart } from '../charts/BurnDownChart';
import BurnUpChart from '../charts/BurnUpChart';
import CummulativeChart from '../charts/CummulativeChart';
import VelocityChart from '../charts/SprintVelocity';

export const Analytics = () => {
  const { columns } = useKanbanStore(boardSelector, shallow);
  const { sprints, setAnalyticsData, analyticsData } = useAgileStore();
  const completedTasks = getCompletedTasks(columns);
  const incompletedTasks = getIncompleteTasks(columns);
  const totalTasks = getTotalTasks(columns);
  const overDueTasks = getOverDueTasks(columns);
  const router = useRouter();
  const fileId = router?.query?.slug as string;

  useEffect(() => {
    const fetchAnalytics = async () => {
      const data = await getFileAnalytics(fileId);
      setAnalyticsData(data);
    };
    fetchAnalytics();
  }, []);

  return (
    <div className="max-w-1180 mx-auto bg-gray-100 min-h-full p-32">
      <div className="flex mb-32">
        <Chip
          icon="✅"
          number={analyticsData?.completed_workload || 0}
          label="Completed workload"
        />
        <Chip
          icon="🚫"
          number={analyticsData?.remaining_workload || 0}
          label="Remaining workload"
        />
        <Chip
          icon="⚡️"
          number={(Math.round(analyticsData?.team_velocity) || 0) + ' points'}
          label="Team velocity"
        />
        <Chip
          icon="🔢"
          number={(Math.round(analyticsData?.team_velocity) || 0) + ' points'}
          label="Team capacity"
        />
      </div>
      <div className="grid grid-cols-2 gap-y-30" style={{ width: '1100px' }}>
        <BurnUpChart data={analyticsData?.data} />
        <BurnDownChart data={analyticsData?.data} members={[]} />
        <CummulativeChart data={analyticsData?.cfd} />
        <VelocityChart data={analyticsData?.sprint_velocity} />
      </div>
    </div>
  );
};

const boardSelector = (state: KanbanState) => ({
  columns: state.columns,
});
